import React, {Key} from 'react';
import '@material-ui/core/styles/withStyles';
import {TableRow} from '@material-ui/core';
import {curry} from 'ramda';
import {RowData, OnRowClickCallback} from './tableTypes';
import RowCell from './RowCell';

export interface RowProps {
    index: number;
    style: {};
    data: RowData;
}

export interface GetRowCellArgs {
    items: any[];
    index: number;
    rowHeight: number;
    key: Key;
    onRowClick: OnRowClickCallback;
}

export type RowCellProps = {
    items: any[];
    index: number;
    rowHeight: number;
    key: React.ReactText;
    onRowClick: OnRowClickCallback;
}

export const rowCellKey = (key: Key, index: number) => {
    return `${key}:${index}`;
};

export const isEqual = (a: Key, b: Key|undefined) => {
    return a === b;
};

export const getRowCell = curry((rowCellProps: RowCellProps, column, columnIndex) => {
    const {
        items,
        index,
        rowHeight,
        key,
        onRowClick,
    } = rowCellProps;
    
    const item = items[index];
    const keyForCell = rowCellKey(key, columnIndex);
    
    const onClickWithItem = onCellClick({
        item: items[index],
        column: column.dataKey,
        onRowClick,
    });
    
    return (
        <RowCell
            key={keyForCell}
            item={item}
            rowHeight={rowHeight}
            column={column}
            onCellClick={onClickWithItem}
        />
    );
});

export const onCellClick = curry(({item, column, onRowClick}, e) => {
    onRowClick(e, item, column);
});

const Row = ({index, style, data: {columns, items, rowHeight, itemKey, onRowClick, selectedRowKey}}:RowProps) => {
    const key = itemKey(
        index,
        {
            items,
        },
    );
    const withItemsAndRowHeight = getRowCell({
        items,
        index,
        rowHeight,
        key,
        onRowClick,
    });
    const rowCells = columns.map(withItemsAndRowHeight);
    
    const selected = isEqual(key, selectedRowKey);
    return (
        <TableRow
            selected={selected}
            component="div"
            className="row"
            style={style}
        >
            {rowCells}
        </TableRow>
    );
};

export default Row;
